import { IconSet } from '@postscript/components';
import {
  CONVERSATION_VIEW_ENABLED,
  SSAI,
} from 'components/admin/utils/feature-flags';
import UnresolvedNotificationsBadge from 'components/responses/UnresolvedNotificationsBadge';
import { usePSLabs } from 'controllers/contexts/labsFeatures';
import { useShopperStatus } from 'hooks/useShopperStatus';
import { useMemo } from 'react';
import { NavMenuItem } from '../NavMenu';

export const useMessagingMenuItems = (): NavMenuItem[] => {
  const shopperStatusContext = useShopperStatus();
  const { hasLabsFlag } = usePSLabs();

  const shouldShowConversationsView =
    hasLabsFlag(SSAI) || hasLabsFlag(CONVERSATION_VIEW_ENABLED);

  return useMemo(
    () => [
      {
        id: 'messaging',
        label: 'Messaging',
        icon: IconSet.Message,
        isLoading: false,
        ariaLabelledBy: 'nav-messaging-title',
        notification: UnresolvedNotificationsBadge(true),
        subMenu: [
          {
            link: '/campaigns',
            label: 'Campaigns',
            id: 'messaging-campaigns',
          },
          {
            link: '/automations',
            label: 'Automations',
            id: 'messaging-automations',
          },
          { link: '/segments', label: 'Segments', id: 'messaging-segments' },
          ...(shouldShowConversationsView
            ? []
            : [
                {
                  link: '/responses',
                  label: 'Responses',
                  id: 'messaging-responses',
                  notification: UnresolvedNotificationsBadge(false),
                },
              ]),
          ...(shouldShowConversationsView
            ? [
                {
                  link: `/conversations${
                    shopperStatusContext.isLive ? '' : '?resolved=false'
                  }`,
                  label: 'Conversations',
                  id: 'messaging-conversations',
                  notification: UnresolvedNotificationsBadge(false),
                },
              ]
            : []),
        ],
      },
    ],
    [shopperStatusContext, shouldShowConversationsView],
  );
};
